import {
    createFetchReducer,
    INITIAL_FETCH_STATE
} from '../../../../../../../middleware';
import { UserProfileModalState } from './user-profile.types';

export const USER_PROFILE_MODAL_NAME = 'userProfileModal';

export const INITIAL_USER_PROFILE_MODAL_STATE: UserProfileModalState = {
    data: null,
    isLoading: false,
    isError: false,
    isSuccess: false,
    error: null
};

export const INITIAL_CONFIGURATION_STATE: UserProfileModalState = {
    ...INITIAL_FETCH_STATE,
    isSuccess: true
};

export const userProfileModalReducer = () => {
    return createFetchReducer(
        USER_PROFILE_MODAL_NAME,
        INITIAL_USER_PROFILE_MODAL_STATE
    );
};
